<template>
  <div class="w-100 customer-order-wrapper">
    <b-row class="mb-5">
      <b-col md="2">
        <b-input-group>
          <date-picker
            placeholder="Từ"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="filterForm.createdFromDate"
          ></date-picker>
        </b-input-group>
      </b-col>
      <b-col md="2">
        <b-input-group>
          <date-picker
            placeholder="Đến"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="filterForm.createdToDate"
          ></date-picker>
        </b-input-group>
      </b-col>
      <b-col md="2">
        <b-form>
          <b-form-select
            v-model="filterForm.statusId"
            :options="ORDER_STATUS"
            size="sm"
          ></b-form-select>
        </b-form>
      </b-col>
      <b-col md="1">
        <b-button
          class="font-weight-bolder customer-order-btn"
          variant="primary"
          size="sm"
          @click="onClickFilter"
          >Lọc
        </b-button>
      </b-col>
    </b-row>
    <table class="table table-bordered-list table-hover col-md-12">
      <thead>
        <tr>
          <th class="text-center header-table-color icon-width"></th>
          <th class="text-center header-table-color id-width">ID</th>
          <th class="text-center header-table-color customer-width">
            Khách hàng
          </th>
          <th class="text-center header-table-color product-width">Sản phẩm</th>
          <th class="text-center header-table-color">Giá</th>
          <th class="text-center header-table-color">SL</th>
          <th class="text-center">Tổng tiền</th>
          <th class="text-center header-table-color">Thanh toán</th>
          <th class="text-center header-table-color note-width">Ghi chú</th>
          <th class="text-center header-table-color">Trạng thái</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(order, i) in mainList.dataset">
          <template v-for="(orderItem, j) in order.orderItems">
            <tr
              :key="i + j + orderItem.id"
              @mouseover="hoverRow"
              @mouseleave="outRow"
              :data="`row_${order.id}`"
            >
              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="td-center"
              >
                <div class="mt-3">
                  <i
                    v-if="order.orderType === ENUM.TYPE_ORDER.SHOP"
                    class="fas fa-store icon-color text-warning"
                    v-b-tooltip.hover.bottom
                    title="Mua tại quầy"
                  ></i>

                  <i
                    v-else-if="order.orderType === ENUM.TYPE_ORDER.PREORDER"
                    class="fas fa-shopping-basket icon-color text-danger"
                    v-b-tooltip.hover.bottom
                    title="Đặt trước"
                  ></i>
                  <i
                    v-else-if="order.orderType === ENUM.TYPE_ORDER.SHIPPING"
                    class="fas fa-truck icon-color text-success"
                    v-b-tooltip.hover.bottom
                    title="Tự vận chuyển"
                  ></i>
                  <i
                    v-else-if="order.orderType === ENUM.TYPE_ORDER.EX_SHIPPING"
                    class="fas fa-box icon-color text-primary"
                    v-b-tooltip.hover.bottom
                    title="Hãng vận chuyển (Ahamove, Nhất tín ...)"
                  ></i>
                  <i
                    v-else-if="order.orderType === ENUM.TYPE_ORDER.WEBSITE"
                    class="fas fa-globe-asia text-dark"
                    v-b-tooltip.hover.bottom
                    title="Website"
                  ></i>
                </div>
              </td>
              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="td-center"
              >
                <router-link
                  class="order-code text-primary font-weight-bolder mb-1"
                  :to="{
                    path: `/orders/edit-order/${order.id}`,
                  }"
                  target="_blank"
                  >{{ order.id }}
                </router-link>
                <p class="mb-2">
                  {{ formatDate(order.createdAt, 'DD/MM/YYYY HH:mm') }}
                </p>
                <p class="mb-0">
                  {{ order.createdByName }}
                </p>

                <strong v-if="order.store?.name">
                  {{ order.store.name }}
                </strong>
              </td>
              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="td-center"
              >
                <p class="order-code mb-0 font-weight-bolder">
                  {{ order.customerName }}
                </p>
                <p class="order-code mb-0">
                  {{ order.customerMobile }}
                </p>
                <div
                  v-if="
                    order.customerAddress &&
                    order.customerAddress.trim().length > 0
                  "
                >
                  <strong>ĐC:</strong>
                  {{ order.customerAddress }}
                </div>
              </td>
              <!--Start of product name-->
              <td class="align-middle">
                <template
                  v-if="
                    orderItem.orderItemProductType ===
                    ENUM.ORDER_ITEM_PRODUCT_TYPE.MAIN
                  "
                >
                  <p style="font-weight: 600" class="m-0 productName">
                    {{ orderItem.product.name }}
                    <MerchantLabel :merchantId="orderItem.merchantId" />
                  </p>
                  <div v-if="orderItem.productChassis" class="text-imei-no">
                    SK: {{ orderItem.productChassis.chassisNumber }} <br />
                    SM: {{ orderItem.productChassis.engineNumber }}
                  </div>
                  <div v-if="orderItem.productSeries" class="text-imei-no">
                    SERI: {{ orderItem.productSeries.serialNumber }}
                  </div>
                </template>
                <template
                  v-else-if="
                    orderItem.orderItemProductType ===
                    ENUM.ORDER_ITEM_PRODUCT_TYPE.GIFT
                  "
                >
                  <p class="m-0">
                    <i
                      class="fas fa-gift icon-color ml-4"
                      style="color: rgb(46, 125, 50)"
                    ></i>
                    {{ orderItem.productName }}
                    <MerchantLabel :merchantId="orderItem.merchantId" />
                  </p>
                  <div v-if="orderItem.productChassis" class="text-imei-no">
                    SK: {{ orderItem.productChassis.chassisNumber }} <br />
                    SM: {{ orderItem.productChassis.engineNumber }}
                  </div>
                  <div v-if="orderItem.productSeries" class="text-imei-no">
                    SERI: {{ orderItem.productSeries.serialNumber }}
                  </div>
                </template>
                <!--Start of product combos-->
                <table>
                  <tr
                    v-show="
                      orderItem.productInCombos &&
                      orderItem.productInCombos.length > 0
                    "
                    v-for="(items, index) in orderItem.productInCombos"
                    :key="index"
                    class="product-combo-border-top"
                  >
                    <td class="border-0">
                      <i
                        v-b-tooltip.hover
                        title="Sản phẩm"
                        class="fas fa-cube icon-color"
                      ></i>
                    </td>
                    <td class="border-0">
                      {{ items.productName }}({{ items.quantity }})
                    </td>
                  </tr>
                </table>

                <!--End of product combos-->
              </td>
              <!--End of product name-->
              <td class="text-right align-middle">
                {{ convertPrice(orderItem.productPrice) }}
                <p
                  v-b-tooltip.hover.bottom
                  title="Chiết khấu sản phẩm"
                  v-if="Number(orderItem.discountAmount)"
                >
                  <i
                    class="fa fa-arrow-down icon-color text-center font-size-sm"
                  ></i
                  >:
                  <strong class="text-warning">
                    {{ convertPrice(orderItem.discountAmount) }}</strong
                  >
                </p>
              </td>
              <td class="text-center align-middle">
                {{ orderItem.quantity }}
              </td>
              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="text-right align-middle"
              >
                <p v-show="order.customerShipFee > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Phí ship"
                    class="fas fa-shipping-fast icon-color"
                  ></i>
                  : {{ convertPrice(order.customerShipFee) }}
                </p>
                <p v-show="order.shipFee > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Phí trả hãng vận chuyển"
                    class="fas fa-hand-holding-usd icon-color"
                  ></i>
                  : {{ convertPrice(order.shipFee) }}
                </p>
                <p v-show="order.discountAmount > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Chiết khấu"
                    class="fa fa-arrow-down icon-color"
                  ></i>
                  : {{ convertPrice(order.discountAmount) }}
                  <span
                    v-if="
                      order.discountType === ENUM.DISCOUNT_AMOUNT_TYPE.PERCENT
                    "
                  >
                    %
                  </span>
                </p>
                <strong class="total-amount-text-color">
                  {{ convertPrice(order.totalAmount) }}</strong
                >
              </td>

              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="text-right align-middle"
              >
                <p v-show="order.depositAmount > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Đặt cọc"
                    class="fa fa-money-check-alt icon-color"
                  ></i>
                  : {{ convertPrice(order.depositAmount) }}
                </p>
                <p v-show="order.transferAmount > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Đã chuyển khoản"
                    class="fa fa-university icon-color"
                  ></i>
                  : {{ convertPrice(order.transferAmount) }}
                </p>
                <p v-show="order.creditAmount > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Tiền quẹt thẻ"
                    class="fa fa-credit-card icon-color"
                  ></i>
                  : {{ convertPrice(order.creditAmount) }}
                </p>
                <p v-show="order.installmentAmount > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Trả góp"
                    class="fa fa-cube icon-color"
                  ></i>
                  : {{ convertPrice(order.installmentAmount) }}
                </p>
                <p v-show="order.refundAmount > 0" class="border-0">
                  <i
                    v-b-tooltip.hover
                    title="Hoàn tiền"
                    class="fa-solid fa-money-bill-transfer icon-color"
                  ></i>
                  : {{ convertPrice(order.refundAmount) }}
                </p>
                <span
                  v-show="order.totalAmountCustomerPay < 0"
                  v-b-tooltip.hover
                  title="Tiền thừa"
                  class="border-0 text-success font-weight-bolder"
                  >{{ convertPrice(order.changeMoney) }}
                </span>
                <span
                  v-show="order.totalAmountCustomerPay > 0"
                  v-b-tooltip.hover
                  title="Phải thu khách"
                  class="border-0 text-warning font-weight-bolder"
                  >{{ convertPrice(order.totalAmountCustomerPay) }}
                </span>
              </td>
              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="wrapword"
              >
                <span
                  v-if="order.codeShip && order.codeShip.trim().length > 0"
                  class="d-block mb-1"
                >
                  <strong>Mã vận đơn:</strong> {{ order.codeShip }}
                </span>
                <span
                  v-if="order.couponCode && order.couponCode.trim().length > 0"
                  class="d-block"
                >
                  <strong>Mã coupon:</strong> {{ order.couponCode }}
                </span>
                <p
                  v-if="order.codeShip && order.codeShip.trim().length > 0"
                  class="dashed"
                ></p>
                <p v-if="order.customerNote" class="pre-line">
                  {{ order.customerNote }}
                </p>
                <p
                  v-if="order.customerNote && order.saleNote"
                  class="dashed"
                ></p>
                <p v-if="order.saleNote" class="pre-line">
                  {{ order.saleNote }}
                </p>
              </td>
              <td
                v-if="j === 0 || order.show"
                :rowspan="order.orderItems.length"
                class="align-middle text-center"
              >
                <span v-if="order.cancelStatus" class="d-block">
                  ({{ getStatusCancelName(order.cancelStatus) }})
                </span>
                <span
                  v-text="getStatusName(order.status)"
                  style="width: max-content"
                  :class="bindClassNameStatus(order)"
                ></span>
                <div
                  v-if="
                    order.status === ENUM.ORDER_STATUS.SUCCESS &&
                    order.bill?.billNumber
                  "
                  class="mt-2"
                >
                  <span
                    v-text="order.bill?.billNumber"
                    @click="linkToBill(order.bill?.billNumber)"
                    class="order-code bill-number-color"
                  ></span>
                  <div class="mt-4">
                    <p v-if="order.bill?.deleted === ENUM.BILL_STATE.DELETED">
                      <i
                        class="fa fa-exclamation-triangle text-danger"
                        v-b-tooltip.hover.bottom
                        title="Hoá đơn đã được xoá"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p v-if="order.billState === ENUM.BILL_STATE.NO_AMOUNT">
                      <i
                        class="fa fa-exclamation-triangle text-warning"
                        v-b-tooltip.hover.bottom
                        title="Hoá đơn không có doanh thu"
                        aria-hidden="true"
                      ></i>
                    </p>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </template>
        <tr v-show="!onLoadingList">
          <td
            colspan="4"
            class="align-middle text-right icon-color font-weight-bolder"
          >
            Tổng
          </td>
          <td></td>
          <td class="align-middle text-right icon-color font-weight-bolder">
            {{ sumQuantity }}
          </td>
          <td class="align-middle text-right icon-color font-weight-bolder">
            <p class="mb-0">
              <i
                v-b-tooltip.hover
                title="Phí vận chuyển"
                class="fa fa-truck header-table-color inherit-font-size"
              ></i>
              {{ convertPrice(sumShipFee) }}
            </p>
            <p class="mb-0">
              <i
                v-b-tooltip.hover
                title="Phí ship báo khách"
                class="fas fa-user header-table-color inherit-font-size"
              ></i>
              {{ convertPrice(sumCustomerShipFee) }}
            </p>
          </td>
          <td class="align-middle text-right icon-color font-weight-bolder">
            <p class="mb-0">
              <i
                v-b-tooltip.hover
                title="Tổng chuyển khoản"
                class="fas fa-university header-table-color inherit-font-size"
              ></i>
              {{ convertPrice(sumTransferAmount) }}
            </p>
            <p class="mb-0">
              <i
                v-b-tooltip.hover
                title="Tổng đặt cọc"
                class="fas fa-user header-table-color inherit-font-size"
              ></i>
              {{ convertPrice(sumDepositAmount) }}
            </p>
            <p class="mb-0" v-b-tooltip.hover title="Tổng thu">
              {{ convertPrice(sumTotalAmount) }}
            </p>
          </td>
          <td colspan="2"></td>
        </tr>
      </tbody>
    </table>
    <vcl-table
      v-if="onLoadingList"
      :speed="5"
      :animate="true"
      :columns="10"
    ></vcl-table>
    <b-row>
      <b-col lg="3" md="3" sm="12">
        <p class="mt-3 text-dark" style="font-weight: 500">
          Tổng số:
          {{ mainList.total }}
        </p>
      </b-col>
      <b-col lg="9" md="9" sm="12">
        <b-pagination-nav
          pills
          v-show="showPagination"
          :link-gen="linkGen"
          v-model="currentPage"
          :number-of-pages="mainList.pages"
          use-router
          @change="fetchMainData()"
          align="right"
        ></b-pagination-nav>
      </b-col>
    </b-row>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import 'src/assets/sass/components/_variables.bootstrap.scss';
.customer-order-wrapper {
  input::-webkit-input-placeholder {
    color: #bebec8;
  }

  .autosuggest__results ul {
    list-style: none;
    cursor: pointer;
    margin-bottom: 0;
  }

  .autosuggest__results ul li {
    padding: 8px;
  }

  .td-center {
    vertical-align: middle;
  }

  .icon-color {
    color: $light-75;
  }

  .header-table-color {
    color: $light-75;
  }

  .table-bordered-list th {
    border: 0.5px solid $light-25 !important;
    background-color: $light-0;
  }

  .table-bordered-list td {
    border: 0.5px solid $light-25;
  }

  .dashed {
    border: 1px dashed $gray-700;
    border-style: none none dashed;
    background-color: #fff;
  }

  input {
    border: 1px solid $light-25;
  }

  .wrapword {
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }

  .pre-line {
    white-space: pre-line;
  }

  .customer-order-btn {
    width: fit-content;
  }

  .icon-width {
    width: 2%;
  }

  .customer-width {
    width: 10%;
  }

  .product-width {
    width: 20%;
  }

  .id-width {
    width: 2%;
  }

  .note-width {
    width: 15%;
  }

  .inherit-font-size {
    font-size: inherit;
  }

  .bill-number-color {
    color: $warning-75;
  }

  .total-amount-text-color {
    color: $success-native;
  }

  .status-width {
    width: max-content;
  }

  .product-combo-border-top {
    border-top: 1px solid $gray-500;
  }

  .text-imei-no {
    font-size: 12px;
    font-style: italic;
    color: dodgerblue;
  }

  .order-code:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>

<script>
import { VclTable } from 'vue-content-loading';
import ApiService from '@/core/services/api.service';
import jQuery from 'jquery';
import {
  formatDate,
  convertPrice,
  makeToastFaile,
  cleanParams,
} from '@/utils/common';

import {
  TIME_OUT,
  ORDER_CANCEL_STATUS,
  ORDER_STATUS as ORDER_STATUS_NAME,
} from '@/utils/constants';
import * as ENUM from '@/utils/enum';
import moment from 'moment';
import MerchantLabel from './MerchantLabel.vue';

export default {
  props: ['customerId'],
  components: {
    VclTable,
    MerchantLabel,
  },
  data() {
    return {
      ENUM,
      ORDER_STATUS_NAME,
      mainList: {
        dataset: [],
        total: 0,
        pages: 1,
      },
      filterForm: {
        createdFromDate: null,
        createdToDate: null,
        statusId: null,
      },
      onLoadingList: false,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      currentPage: 1,
      sumShipFee: 0,
      sumCustomerShipFee: 0,
      sumTransferAmount: 0,
      sumDepositAmount: 0,
      sumTotalAmount: 0,
      sumQuantity: 0,
      optionCancelStatus: ORDER_CANCEL_STATUS,
      hoverTable: {
        dataId: null,
      },
    };
  },
  mounted() {
    this.fetchMainData();
  },
  methods: {
    formatDate,
    convertPrice,
    hoverRow: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      if (this.hoverTable.dataId !== dataId) {
        const rows = jQuery(`[data=${dataId}]`);
        rows.addClass('tr-rowspan-hover');
        this.hoverTable.dataId = dataId;
      }
    },
    outRow: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      const rows = jQuery(`[data=${dataId}]`);
      rows.removeClass('tr-rowspan-hover');
      this.hoverTable.dataId = null;
    },
    onClickFilter() {
      this.currentPage = 1;
      this.fetchMainData();
    },
    async fetchMainData() {
      if (!this.customerId) {
        makeToastFaile('Không tìm thấy Id khách hàng');
        return;
      }
      this.currentPage = parseInt(this.$route.query.page) || 1;
      const params = this.getParamFilters();
      const cleanedParams = cleanParams(params);

      this.onLoadingList = true;
      ApiService.setHeader();

      try {
        const response = await ApiService.query(
          'orders',
          { params: cleanedParams },
          { timeout: TIME_OUT },
        );

        const data = response.data.data;
        this.mainList.pages = data.paginations.totalPages || 1;
        this.mainList.total = data.paginations.total;
        this.orders = [];
        this.sumQuantity = 0;
        this.sumShipFee = 0;
        this.sumCustomerShipFee = 0;
        this.sumTransferAmount = 0;
        this.sumDepositAmount = 0;
        this.sumTotalAmount = 0;
        const dataset = [];

        data.data.map((item) => {
          // Sort orderItems: MAIN → child items → remaining items
          const sortedOrderItems = [];
          const mainItems = item.orderItems
            .filter(
              (oi) =>
                oi.orderItemProductType === ENUM.ORDER_ITEM_PRODUCT_TYPE.MAIN,
            )
            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

          mainItems.forEach((mainItem) => {
            sortedOrderItems.push(mainItem);
            const childItems = item.orderItems.filter(
              (oi) => oi.belongOrderDetailId === mainItem.id,
            );
            sortedOrderItems.push(...childItems);
          });

          const remainingItems = item.orderItems.filter(
            (oi) =>
              oi.orderItemProductType !== ENUM.ORDER_ITEM_PRODUCT_TYPE.MAIN &&
              !oi.belongOrderDetailId,
          );
          sortedOrderItems.push(...remainingItems);

          const order = {
            ...item,
            orderItems: sortedOrderItems,
            groupSize: sortedOrderItems.length,
            show: sortedOrderItems.length <= 0 ? true : false,
            selected: false,
          };
          //  tiền thừa cho khách
          order.changeMoney =
            item.totalAmountCustomerPay < 0
              ? item.totalAmountCustomerPay * -1
              : item.totalAmountCustomerPay;

          this.sumQuantity = order.orderItems.reduce((acc, cur) => {
            return acc + cur.quantity;
          }, this.sumQuantity);

          this.sumShipFee += Number(order.shipFee);
          this.sumCustomerShipFee += Number(order.customerShipFee);
          this.sumTransferAmount += Number(order.transferAmount);
          this.sumDepositAmount += Number(order.depositAmount);
          this.sumTotalAmount += Number(order.totalAmount);

          dataset.push(order);
        });

        this.mainList.dataset = dataset;
        this.onLoadingList = false;
      } catch (error) {
        this.onLoadingList = false;
        if (error.response) {
          makeToastFaile(
            error.response.data ? error.response.data.message : 'Lỗi',
          );
        } else {
          makeToastFaile(error.message || 'Lỗi');
        }
      }
    },
    getParamFilters() {
      const params = {
        customerId: this.customerId,
        page: this.currentPage,
      };

      if (this.filterForm.createdFromDate) {
        params.createdFromDate = moment(
          this.filterForm.createdFromDate,
          'DD/MM/YYYY',
        ).format('YYYY-MM-DD');
      }

      if (this.filterForm.createdToDate) {
        params.createdToDate = moment(
          this.filterForm.createdToDate,
          'DD/MM/YYYY',
        ).format('YYYY-MM-DD');
      }

      if (this.filterForm.statusId) {
        params.statusIds = [this.filterForm.statusId];
      }

      return params;
    },

   
    linkGen(pageNum) {
      return pageNum === 1
        ? `?id=${this.customerId}`
        : `?id=${this.customerId}&page=${pageNum}`;
    },
    getStatusName(id) {
      const status = this.ORDER_STATUS.find((s) => s.value === id);
      return status ? status.text : '';
    },
    getStatusCancelName(id) {
      const cancelStt = this.optionCancelStatus.find((x) => x.value == id);
      if (cancelStt) return cancelStt.text;
      return 'Chưa có trạng thái lý do';
    },
    bindClassNameStatus(order) {
      let className = '';
      switch (order.status) {
        case ENUM.ORDER_STATUS.NEW: {
          className = 'badge badge-warning text-white';
          break;
        }
        case ENUM.ORDER_STATUS.CONFIRMING: {
          className = 'badge badge-light';
          break;
        }
        case ENUM.ORDER_STATUS.CONFIRMED: {
          className = 'badge badge-primary text-white';
          break;
        }
        case ENUM.ORDER_STATUS.AGREE_DEPOSIT: {
          className = 'badge badge-dark-blue text-white';
          break;
        }
        case ENUM.ORDER_STATUS.KEEP_DEPOSIT:
        case ENUM.ORDER_STATUS.DELIVERY: {
          className = 'badge badge-warning';
          break;
        }
        case ENUM.ORDER_STATUS.TRACKING:
        case ENUM.ORDER_STATUS.PACKING: {
          className = 'badge badge-info';
          break;
        }
        case ENUM.ORDER_STATUS.SUCCESS: {
          className = 'badge badge-success';
          break;
        }
        case ENUM.ORDER_STATUS.UN_SUCCESS:
        case ENUM.ORDER_STATUS.SYSTEM_CANCEL:
        case ENUM.ORDER_STATUS.CR_CANCEL: {
          className = 'badge badge-dark';
          break;
        }
        case ENUM.ORDER_STATUS.REFUNDED:
        case ENUM.ORDER_STATUS.DEPOSIT: {
          className = 'badge badge-danger';
          break;
        }
        case ENUM.ORDER_STATUS.NO_CATCHED_PHONE: {
          className = 'badge badge-secondary';
          break;
        }
        case ENUM.ORDER_STATUS.PREPARED:
        case ENUM.ORDER_STATUS.HOLDING: {
          className = 'badge badge-warning';
          break;
        }
      }
      return className;
    },
  },
  computed: {
    ORDER_STATUS() {
      return ORDER_STATUS_NAME;
    },
    showPagination() {
      return this.mainList.pages >= 2;
    },
  },
};
</script>
